import { https } from "./apiPayment";

export default class {
  constructor() {
    this.instance = https("/sitef");
  }
  getCardRegistration = data => {
    return this.instance({
      method: "POST",
      url: "/store/mail/",
      data
    });
  };
}
